module.exports = __webpack_public_path__ + "kudos_6.svg?0cd61a5e58d9176c3ebb1b011f2f4584";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_6.svg
// module id = 161
// module chunks = 0